import * as atypes from 'common/actions/integrations/common/constants/IntegrationsReduxActionTypes'
import { activeCampaignApi } from 'shared/api/requests/integrations/activeCampaign'
import { createAsyncAction } from 'shared/lib/redux'

export const setIdentityField = ({ value, option }) => {
  return {
    type: atypes.ACTIVE_CAMPAIGN_SET_IDENTITY_FIELD,
    data: {
      value,
      option,
    },
  }
}

export const fetchLists = createAsyncAction('integration/activeCampaign/fetchLists', async () => {
  const response = await activeCampaignApi.getLists()
  return response.data
})

export const setSelectedList = (list) => ({
  type: atypes.ACTIVE_CAMPAIGN_SET_LIST,
  data: list,
})

export const setFieldEmptiness = (data) => ({
  type: atypes.ACTIVE_CAMPAIGN_SET_FIELD_EMPTINESS,
  data,
})

export const fetchAvailableIntegrationFields = createAsyncAction(
  'integration/activeCampaign/fetchAvailableIntegrationFields',
  async () => {
    const response = await activeCampaignApi.getFields()
    return response.data
  },
)
